import React from 'react';

const Hero = () => {
    return (
        <>
            <section id="inicio" className="hero-pattern min-h-screen flex items-center relative pt-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-20">
                    <div className="max-w-3xl">
                        <span className="inline-block py-1 px-3 rounded-full bg-brand-500/20 text-brand-400 font-semibold text-sm mb-6 border border-brand-500/30 backdrop-blur-sm">
                            El Sistema Operativo de tu Taller
                        </span>
                        <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6">
                            Gestiona tu taller con <span className="text-brand-500">inteligencia real</span>
                        </h1>
                        <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl leading-relaxed">
                            Inventario en tiempo real, agendamiento automático, historial clínico del vehículo y facturación rápida. Todo en una sola plataforma diseñada para talleres que quieren crecer sin perder el control.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4">
                            <a href="#contacto" className="bg-brand-600 text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-brand-500 transition-all text-center flex items-center justify-center gap-2 shadow-lg shadow-brand-600/30 group">
                                Registrar mi Taller <i data-lucide="arrow-right" className="w-5 h-5 group-hover:translate-x-1 transition-transform"></i>
                            </a>
                            <a href="#servicios" className="bg-white/10 text-white backdrop-blur-md border border-white/20 px-8 py-4 rounded-full font-semibold text-lg hover:bg-white/20 transition-all text-center">
                                Ver Funciones
                            </a>
                        </div>

                        {/* Quick Stats */}
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mt-16 pt-8 border-t border-white/10">
                            <div>
                                <h4 className="text-3xl font-bold text-white mb-1">Cero</h4>
                                <p className="text-gray-400 text-sm">Pérdidas por repuestos no cobrados</p>
                            </div>
                            <div>
                                <h4 className="text-3xl font-bold text-white mb-1">100%</h4>
                                <p className="text-gray-400 text-sm">Control de stock en tiempo real</p>
                            </div>
                            <div className="hidden md:block">
                                <h4 className="text-3xl font-bold text-white mb-1">1 clic</h4>
                                <p className="text-gray-400 text-sm">De cotización a factura</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Botón Flotante de WhatsApp */}
            <a
                href="https://wa.me/573164344145"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-6 right-6 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:bg-[#128C7E] hover:scale-110 transition-all duration-300 z-50 flex items-center justify-center group"
                aria-label="Escríbenos por WhatsApp"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                    className="w-8 h-8"
                >
                    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c-.003 1.396.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/>
                </svg>
            </a>
        </>
    );
};

export default Hero;